var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-app",
    [
      _vm.signedIn == true
        ? _c(
            "v-app-bar",
            { attrs: { app: "", dense: "", height: "48" } },
            [
              _c(
                "h1",
                { staticClass: "ml-4 screen-title" },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "mr-3",
                      attrs: { color: "black", size: "30" },
                      on: {
                        click: function ($event) {
                          return _vm.$router.push("Home")
                        },
                      },
                    },
                    [_vm._v("mdi-home")]
                  ),
                  _c("span", [_vm._v(_vm._s(_vm.appTitle) + " / ")]),
                  _c("span", [_vm._v(_vm._s(_vm.$router.currentRoute.name))]),
                ],
                1
              ),
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: {
                    link: "",
                    text: "",
                    small: "",
                    to: { name: "About" },
                  },
                },
                [
                  _c(
                    "v-avatar",
                    {
                      staticStyle: { border: "solid 1px rgba(0, 0, 0, 0.12)" },
                      attrs: { size: "32" },
                    },
                    [
                      _c("v-icon", { attrs: { color: "primary" } }, [
                        _vm._v("mdi-account"),
                      ]),
                    ],
                    1
                  ),
                  _vm._v(
                    " " +
                      _vm._s(_vm.userInfo != null ? _vm.userInfo.email : "") +
                      " "
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-main",
        { staticStyle: { "background-color": "rgba(0, 0, 0, 0.12)" } },
        [_c("router-view")],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }